import { add, startOfDay } from '@lingoda/dates';

export const getFetchMoreDate = (lastClassStartDate: Date) =>
    startOfDay(add({ days: 1 }, lastClassStartDate));
